<template>
  <div class="white-wrapper">
    <div class="section-title">
      {{ $t("Staff Performance Report") }}
    </div>
    <div class="mt-3 mb-2">
      <div class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-3">
          <div class="dropdown-curve-container">
            <label
              :class="
                dropDown.cinemas && dropDown.cinemas.length > 0
                  ? 'shift-up'
                  : ''
              "
              >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
            >
            <multiselect
              :disabled="isRoleID"
              :options="dropDown.cinemas"
              v-model="dropDown.selectedCinema"
              :searchable="true"
              label="cine_name"
              track-by="cine_id"
              placeholder="Select Cinema"
              @input="onSelectCinema($event)"
              :allowEmpty="false"
              :showLabels="false"
            ></multiselect>
          </div>
        </div>
        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="input-material">
            <div class="add-datepicker">
              <Datepicker
                :monday-first="true"
                type="date"
                ref="programaticOpen"
                v-model="fromDate"
                v-validate="'required'"
                @selected="onChangeDate($event, 'from')"
              ></Datepicker>
              <label :class="fromDate ? 'active' : ''">
                {{ $t("fromdate") }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="input-material">
            <div class="add-datepicker">
              <Datepicker
                :monday-first="true"
                ref="programaticOpen"
                v-model="toDate"
                v-validate="'required'"
              >
              </Datepicker>
              <label :class="toDate ? 'active' : ''"> {{ $t("todate") }}</label>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xl-2 align-self-center mb-3">
          <button
            class="btn-blue-lg w-100"
            @click.prevent="GetStaffPerfromanceReport('N')"
          >
            {{ $t("fetch") }}
            {{ $t("report") }}
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="staffPerformanceData.length > 0"
      class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
    >
      <div class="mx-1">{{ $t("download") }} as:</div>

      <a
        target="_blank"
        @click="
          GetStaffPerfromanceReport(
            (isPdfDownload = 'Y'),
            (isExcelDownload = 'Y')
          )
        "
        title="Download as PDF"
        download
      >
        <img
          class="mx-1"
          src="@/assets/img/icons/pdf.svg"
          height="25"
          width="25"
        />
      </a>
      <a
        target="_blank"
        @click="
          GetStaffPerfromanceReport(
            (isPdfDownload = 'N'),
            (isExcelDownload = 'Y')
          )
        "
        title="Download as Excel"
        download
      >
        <img
          class="mx-1"
          src="@/assets/img/icons/excel.svg"
          height="25"
          width="25"
        />
      </a>
    </div>

    <div
      style="overflow-x:scroll;width: auto !important"
      ref="exportable_table"
    >
      <table class="swc-report-table" border="1">
        <thead class="font-weight-bold bg-lightgrey">
          <th>Cinema User</th>
          <!-- <th>First Log On</th>
            <th>Last Log Off</th> -->
          <th>Logded on Hours</th>
          <th>Admits (Incl Comps)</th>
          <th>Total Transactions</th>
          <th>Transactions Per Hour</th>
          <th>Concession Transactions</th>
          <th>Transaction Strike Rate</th>
          <th>Concession Value</th>
          <th>Concession Spend Per Head</th>
          <th>Concession Spend Per Hour</th>
        </thead>
        <tbody>
          <template v-for="(data, DataIndex) in staffPerformanceData">
            <tr v-if="DisplayCinemaName(DataIndex)">
              <th class="text-left" colspan="10">{{ data.cinema_name }}</th>
            </tr>

            <tr>
              <td class="text-left">
                {{ data.user_full_name }}
              </td>

              <!-- <td class="text-right">
                -
                  </td>
                  <td class="text-right">
                    -
                  </td> -->
              <td class="text-right">
                {{ data.logged_time_in_hrs }}
              </td>
              <td class="text-right">
                {{ data.admits }}
              </td>
              <td class="text-right">
                {{ data.total_transactions }}
              </td>
              <td class="text-right">
                {{ data.transaction_per_hour }}
              </td>
              <td class="text-right">
                {{ data.concession_transactions }}
              </td>
              <td class="text-right"> {{ data.transaction_strike_rate }}% </td>
              <td class="text-right">
                {{ data.concession_value }}
              </td>
              <td class="text-right">
                {{ data.concession_spend_per_head }}
              </td>
              <td class="text-right">
                {{ data.concession_spend_per_hour }}
              </td>
            </tr>
          </template>

          <tr class="bg-lightgrey">
            <th class="text-left">Grand Total</th>

            <th class="text-right">
              {{ grandTotal("logged_time_in_hrs") }}
            </th>
            <th class="text-right">{{ grandTotal("admits") }}</th>
            <th class="text-right">{{ grandTotal("total_transactions") }}</th>
            <th class="text-right">{{ grandTotal("transaction_per_hour") }}</th>
            <th class="text-right">{{
              grandTotal("concession_transactions")
            }}</th>
            <th class="text-right">
              {{ grandTotal("transaction_strike_rate") }}%
            </th>
            <th class="text-right">
              {{ grandTotal("concession_value") }}
            </th>
            <th class="text-right">
              {{ grandTotal("concession_spend_per_head") }}
            </th>
            <th class="text-right">
              {{ grandTotal("concession_spend_per_hour") }}
            </th>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/NewReportService";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import VueHtml2pdf from "vue-html2pdf";

  export default {
    components: {
      NoRecords,
      VueHtml2pdf,
    },
    data() {
      return {
        BASEURL,
        isRoleID: false,
        submitted: false,

        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
        },
        fromDate: new Date(),
        toDate: new Date(),
        staffPerformanceData: [],
      };
    },
    beforeMount() {
      this.getCinemaList();
    },
    watch: {},
    mounted() {},
    methods: {
      onChangeDate: function(e, type){
        if(type == 'from'){
          this.toDate = new Date(e);
          this.$forceUpdate();
        }
      },
      moment,
      grandTotal(key) {
        return this.staffPerformanceData
          .reduce((acc, item) => {
            return acc + parseFloat(item[key] || 0);
          }, 0)
          .toFixed(this.MIN_FRACTION_DIGITS);
      },
      DisplayCinemaName(index) {
        if (index === 0) {
          return true;
        }
      },
      getCinemaList: function() {
        MasterService.GetCinemas()
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.dropDown.cinemas = data.Records;
              this.CinemasCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectCinema: function(event) {
        this.dropDown.selectedCinema = event;
        this.dropDown.selectedCinemaName = event.cine_name;
        this.dropDown.selectedCinemaId = event.cine_id;
        this.$store.dispatch("selectDropdownCinema", event);
      },
      GetStaffPerfromanceReport(isPdfDownload = "N", isExcelDownload = "N") {
        if (!this.dropDown.selectedCinemaId) {
          return this.$toasted.show("Select Cinema");
        }
        if (!this.fromDate) {
          return this.$toasted.show("Select From Date");
        }
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName || "",
          cinema_address: this.dropDown.selectedCinema.cine_address || "",
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          isPdfDownload,
          isExcelDownload,
        };
        ReportsService.GetStaffPerfromanceReport(payload)
          .then((response) => {
            const { data } = response;
            //console.log("data",data)
            if (data.status && data.Records.length > 0) {
              this.staffPerformanceData = [...data.Records];

              console.log("staffPerformanceData", this.staffPerformanceData);

              if (isPdfDownload == "Y" && data.pdfPath) {
                window.open(data.pdfPath, "_blank");
              }
              if (isExcelDownload == "Y" && data.excelPath) {
                console.log(data.excelPath, "data.excelPathdata.excelPath");
                window.open(data.excelPath, "_blank");
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
    },
  };
</script>

<style>
  .swc-report-table {
    table-layout: auto !important;
    border: 1px solid black;
  }
  .swc-report-table th {
    border: 1px solid black !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/staffPerformanceReport.vue